module.exports = __webpack_public_path__ + "ac8b5b83c8e51b774af0c27ce33a8c74.ttf";